import { RotateCcw } from 'lucide-react'
import { ComponentProps } from 'react'
import { useModalContext } from '../contexts'
import { webchatClasses } from '../styles/classes'

type Props = {
  restartConversation: () => void
} & ComponentProps<typeof RotateCcw>

export const RestartConversationButton = ({ restartConversation, ...props }: Props) => {
  const { header } = webchatClasses
  const { showInputModal } = useModalContext()

  const onClick = async (e: React.SyntheticEvent) => {
    e.stopPropagation()
    if (showInputModal) {
      showInputModal({
        title: 'Create New Conversation',
        description: 'This will clear the current conversation and start a new one.',
        confirmButtonText: 'New conversation',
        cancelButtonText: 'Cancel',
      }).then(() => restartConversation())
    } else {
      restartConversation()
    }
  }

  return (
    <RotateCcw
      {...props}
      {...header?.content?.actions?.icons}
      aria-label="Restart Conversation Button"
      tabIndex={0}
      role="button"
      onClick={onClick}
    />
  )
}
